<template>
  <div class="resume-preview-container">
    <PcNavbar />
    <template v-if="!isLoading">
      <div class="resume-preview-content">
        <div class="resume-wrapper">
          <div class="resume-content">
            <ResumeProfile />
          </div>
        </div>
        <div class="right-content">
          <div class="right-content-title">AI 智能简历已生成</div>
          <template v-if="personalSummary">
            <div class="personal-title">个人信息</div>
            <div
              class="personal-summary-content"
              v-html="personalSummary"
            ></div>
          </template>
          <div class="personal-title">模版风格</div>
          <div class="resume-template-list">
            <div
              v-for="(item, index) in templates"
              :key="index"
              class="template-content"
            >
              <img :src="item" alt="" />
            </div>
          </div>
          <div class="bottom-btns-content">
            <div class="btns-item">重新生成</div>
            <div class="btns-item">使用模版</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import PcNavbar from "@/components/base/navbar";
import { dealCvDataMixin } from "@/assets/js/mixins";
import ResumeProfile from "./components/ResumeProfile/index.vue";
import { CN_CV_STYLES } from "@/assets/js/const";

export default {
  name: "AiResumePreview",
  mixins: [dealCvDataMixin],
  components: {
    PcNavbar,
    ResumeProfile,
  },
  data() {
    return {
      isLoading: true,
      CN_CV_STYLES,
      templates: [
        "https://logo.wondercv.com/banners/a8m8I8bjxupMgKY.png",
        "https://logo.wondercv.com/banners/lPz77PbuLHB1nVm.png",
        "https://logo.wondercv.com/banners/nVvWhBWuIa0ERd2.png",
        "https://logo.wondercv.com/banners/6YQK2KiBQqXRHjH.png",
      ],
    };
  },
  computed: {
    ...mapState("editor", ["resumeWidth"]),
    personalSummary() {
      const infos = this.$store.state.editor.personal_summary;
      if (!infos.length) return "";
      return infos[0].description;
    },
  },
  methods: {
    ...mapActions("editor", ["getCvDetail", "getCvInfoData"]),
    async fetchResumeData(token) {
      try {
        await this.getCvDetail(token);
        await this.getCvInfoData({
          check: false,
          only_desc: false,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    const token = this.$route.params.token;
    this.fetchResumeData(token);
    this.$store.commit("editor/setResumeWidth", {
      value: document.body.offsetWidth,
      type: "new",
    });
  },
};
</script>
<style lang="scss" scoped>
.resume-preview-container {
  padding-top: 116px;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #191c20;
  .resume-preview-content {
    display: flex;
    justify-content: center;
    align-items: center;
    .resume-wrapper {
      width: 460px;
      height: 690px;
      overflow: hidden;
      margin-right: 60px;
      .resume-content {
        width: 210mm;
        height: 297mm;
        border-radius: 16px;
        background-color: #fff;
        transform: scale(0.58);
        transform-origin: left top;
        padding: 12mm 0;
        box-sizing: border-box;
        line-height: 18px;
        font-size: 12px;
      }
    }
    .right-content {
      width: 680px;
      .right-content-title {
        font-size: 32px;
        font-weight: 600;
        line-height: normal;
        background: linear-gradient(90deg, #febe5d 0%, #fe6644 38.24%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 32px;
      }
      .personal-title {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 12px;
      }
      .personal-summary-content {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 12px;
        border: 1px solid #484e5c;
        background: linear-gradient(79deg, #272b33 65%, #523433 100%);
        color: #fff;
        font-size: 16px;
        line-height: normal;
        margin-bottom: 20px;
      }
      .resume-template-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
        .template-content {
          width: 155px;
          height: 218px;
          border-radius: 12px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
          }
        }
      }
      .bottom-btns-content {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .btns-item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 200px;
          height: 54px;
          border-radius: 100px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          &:last-child {
            margin-left: 20px;
            background: linear-gradient(90deg, #ffbe5d 0%, #f64 100%);
            color: #1c212a;
          }
          &:first-child {
            border: 1px solid #fff;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
